import React from "react";
import { Link } from "react-router-dom";

const FinalCTA = () => {
  return (
    <section className="py-16">
      <div className="max-w-5xl mx-auto px-6 text-center">
        <h2 className="text-3xl md:text-4xl font-extrabold text-indigo-900">
          Your Child’s Success Starts Today
        </h2>
        <p className="text-gray-600 mt-2">
          Book a free assessment — get a clear plan tailored to your child.
        </p>
        
        <Link
          to="/register-student"
          className="inline-block mt-6 px-8 py-4 bg-yellow-400 text-black font-semibold rounded-xl shadow-lg hover:bg-yellow-300 transition"
        >
          Free Maths Assessment
        </Link>

        <p className="mt-3 text-xs text-gray-500">
          No payment required. 100% confidential results.
        </p>
      </div>
    </section>
  );
};

export default FinalCTA;
